'use strict';

require('slick-carousel');

const $ = require('jquery');

/**
 * Slick init with scope.
 * @param $scope
 * @constructor
 */
class SlickInit {
    /**
     * Construct the object.
     * @param $scope
     */
    constructor($scope = $('body')) {
        const _ = this;

        this.slickConfigs = {
            default: {
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                dots: false,
                arrows: true,
                infinite: true,
            },
            header: {
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                dots: true,
                arrows: false,
                infinite: true,
                speed: 1400,
            },
        };
        this._$scope = $scope;
        this._slicks = this._getSlicks();

        if (this._slicks.length) {
            this._slicks.each(function() {
                _.initSlider($(this), $(this).attr('data-slider-config'));
            });
        }
    }

    /**
     * Get all slider elements.
     * @returns {*}
     * @private
     */
    _getSlicks() {
        return this._$scope.find('[data-slider-config]');
    }

    /**
     * Init single slide with specified config.
     * @param $el
     * @param strConfig
     */
    initSlider($el, strConfig = 'default') {
        let arrCurrConfig = this.slickConfigs[strConfig];

        $el.on('init', this.addAnimationClass());
        $el.on('afterChange', this.addAnimationClass());

        if (arrCurrConfig && !$el.hasClass('slick-slider')) {
            $el.slick(arrCurrConfig);
        } else {
            console.log('no config found or slick already initialized!');
        }
    }

    /**
     * Add animation function.
     * @returns {(function(*, *, *): void)|*}
     */
    addAnimationClass() {
        let animationTimeout;

        return function(e, Slick, index) {
            Slick.$slides.removeClass('slick-animation');
            let currentSlide = Slick.$slides[index ? index : 0];

            clearTimeout(animationTimeout);

            animationTimeout = setTimeout(() => {
                currentSlide.classList.add('slick-animation');
            }, 100);
        };
    }
}

export default SlickInit;
